// extracted by mini-css-extract-plugin
module.exports = {"logo":"_2HTDlEb","pulse":"_3bZG2ha"};